import { useLocalStorage } from "@elit-hair/elit-tools";
import { SidebarInset, SidebarProvider, useIsMobile } from "@elit-hair/elit-ui";
import { Outlet } from "@tanstack/react-router";
import { useEffect } from "react";

import { LOCAL_STORAGE_KEYS } from "@/constants/local-storage-keys";

import { Header } from "./header";
import { SidebarLeft } from "./sidebar/sidebar-left";

export function Layout() {
    const [leftSidebarOpen, setLeftSidebarOpen] = useLocalStorage<boolean>(
        LOCAL_STORAGE_KEYS.LEFT_SIDEBAR_OPEN.key,
        LOCAL_STORAGE_KEYS.LEFT_SIDEBAR_OPEN.default
    );

    const [rightSidebarOpen, setRightSidebarOpen] = useLocalStorage<boolean>(
        LOCAL_STORAGE_KEYS.RIGHT_SIDEBAR_OPEN.key,
        LOCAL_STORAGE_KEYS.RIGHT_SIDEBAR_OPEN.default
    );

    const isMobile = useIsMobile();

    // Keyboard shortcuts
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            // Left sidebar: Cmd/Ctrl + B
            if (event.key === "b" && (event.metaKey || event.ctrlKey)) {
                event.preventDefault();
                if (!isMobile) {
                    setLeftSidebarOpen((prev) => !prev);
                }
            }
            // Right sidebar: Cmd/Ctrl + I
            if (event.key === "i" && (event.metaKey || event.ctrlKey)) {
                event.preventDefault();
                if (!isMobile) {
                    setRightSidebarOpen((prev) => !prev);
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isMobile, setLeftSidebarOpen, setRightSidebarOpen]);

    const handleToggleRightSidebar = (value: boolean) => {
        setRightSidebarOpen(value);
    };

    return (
        <SidebarProvider open={leftSidebarOpen} onOpenChange={setLeftSidebarOpen}>
            <SidebarLeft />
            <SidebarInset className="flex-1 min-w-0 flex flex-col">
                <Header
                    onToggleRightSidebar={() => handleToggleRightSidebar(!rightSidebarOpen)}
                    showRightSidebarToggle={false}
                />
                <div className="flex-1 gap-4 p-4 overflow-auto min-h-0 max-w-full">
                    <Outlet />
                </div>
            </SidebarInset>
            <SidebarProvider
                open={rightSidebarOpen}
                onOpenChange={handleToggleRightSidebar}
                disableKeyboardShortcut={true}
                mobileSheetTitle="right_panel"
                mobileSheetDescription="right_sidebar_mobile_description"
                className="w-auto h-full shrink-0 bg-transparent"
            ></SidebarProvider>
        </SidebarProvider>
    );
}
